import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BanknotesIcon,
} from "@heroicons/react/24/outline";

// components
import { SectionSubHeader } from "../../components/layouts/section.subheader";

// utilities
import { classNames } from "../../utilities";

export const ScreenJobDetailsPaymentDetails = () => {

  // hooks
  const dispatch = useDispatch();
  const { details } = useSelector(context => context.jobs);


  if (!details) return null;
  return (
    <div className="pb-[10vh] bg-white rounded-2xl shadow-md">

      {/* PERSONAL INFORMATION */}
      <div className="py-8 px-4 border-b border-slate-200">
        <SectionSubHeader title={'Invoice'} Icon={BanknotesIcon} />
        <div className="grid grid-cols-6 gap-4 divide-x divide-slate-200">
          <div className="px-2 col-span-6">
            <p className="mt-4 font-regular uppercase border-b border-slate-100">Summary</p>
            <SideKeyValue label={'Invoice No.'} value={details.invoice.number} />
            <SideKeyValue label={'To'} value={details.invoice.customer_name} />
            <SideKeyValue label={'Customer Email'} value={details.invoice.customer_email} />
            <SideKeyValue label={'From'} value={details.invoice.account_name} />
            <SideKeyValue 
              label={'Invoice URL'} 
              value={
                <a 
                  href={details.invoice.hosted_invoice_url} 
                  target="_blank"
                  className="text-blue-500 hover:underline hover:pointer"
                >
                  Click here
                </a>
              } 
            />

            <p className="mt-10 font-regular uppercase border-b border-slate-100">Items</p>
            {details.invoice.lines.data.map(item => (
              <SideKeyValue label={item.description} value={`${item.currency.toUpperCase()} ${(item.amount/100).toFixed(2)}`} />
            ))}
            <div className="mt-4 pb-4 border-y border-slate-200">
              <SideKeyValue label={'Total Due'} value={`${details.invoice.currency.toUpperCase()} ${(details.invoice.amount_due/100).toFixed(2)}`} />
            </div>
            <SideKeyValue label={'Total Paid'} value={`${details.invoice.currency.toUpperCase()} ${(details.invoice.amount_paid/100).toFixed(2)}`} />
            <SideKeyValue label={'Total Remaining'} value={`${details.invoice.currency.toUpperCase()} ${(details.invoice.amount_remaining/100).toFixed(2)}`} />
          </div>
        </div>
      </div>

    </div>
  );
};

const HeaderKeyValue = ({label, value}) => {
  return (
    <div className="pr-8">
      <h4 className="text-sm text-slate-500 font-normal">{label}</h4>
      <p className="text-base text-slate-800 font-semibold">{value}</p>
    </div>
  )
}


const SideKeyValue = ({label, value}) => {
  return (
    <div className="pt-4 grid grid-cols-8">
      <h4 className="col-span-4 text-sm text-slate-500 font-normal">{label}</h4>
      <span className="col-span-4 text-sm text-slate-900 font-medium text-left">{value}</span>
    </div>
  )
}

const FilterSection = ({title, selected, onSelect = () => {}}) => {
  return (
    <div className={classNames(
      "px-8 py-1 mr-4 border border-slate-200 rounded-xl shadow-sm hover:cursor-pointer",
      selected ? 'bg-primary-500' : 'bg-slate-200',
    )}>
      <p className={classNames(
        "col-span-4 text-sm font-normal",
        selected ? 'text-white': 'text-slate-500'
      )}
      >
        {title}
      </p>
    </div>
  )
}